import Board from './BoardObject';

export default class Game {
    constructor() {
        this.board = new Board();
    }
}